import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Users, Award, TrendingDown } from 'lucide-react';
const proofItems = [{
  icon: BookOpen,
  text: 'Based on 200+ Peer-Reviewed Studies'
}, {
  icon: Users,
  text: 'Designed for Men 50+'
}, {
  icon: Award,
  text: 'Metabolic Engineering Protocol'
}, {
  icon: TrendingDown,
  text: 'Targets A1C Reduction'
}];
export function SocialProofBar() {
  return <section className="w-full py-8 bg-[#0a0a0a] border-b border-gray-800 overflow-hidden" data-id="element-213">
      <div className="max-w-6xl mx-auto px-4" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex flex-nowrap md:flex-wrap overflow-x-auto md:overflow-visible gap-8 md:gap-12 items-center justify-start md:justify-center pb-4 md:pb-0 scrollbar-hide" data-id="element-215">
          {proofItems.map((item, index) => <div key={index} className="flex items-center gap-3 flex-shrink-0" data-id="element-216">
              <item.icon className="w-5 h-5 text-accent" data-id="element-217" />
              <span className="text-xs md:text-sm font-bold uppercase tracking-wider text-gray-400 whitespace-nowrap" data-id="element-218">
                {item.text}
              </span>
            </div>)}
        </motion.div>
      </div>
    </section>;
}